import React, { useRef, useState } from 'react';
import { equipment } from '../mock';
import { Mic, Headphones, Cpu, Music2 } from 'lucide-react';

const iconMap = {
  'Microphones': Mic,
  'Monitors': Headphones,
  'Interface': Cpu,
  'default': Music2
};

const Equipment = () => {
  const videoRef = useRef(null);
  const [videoError, setVideoError] = useState(false);

  return (
    <section className="relative py-20 overflow-hidden">
      {/* Video Background - Same as Hero */}
      <div className="absolute inset-0 w-full h-full">
        <video
          ref={videoRef}
          autoPlay
          loop
          muted
          playsInline
          className="absolute top-1/2 left-1/2 w-full h-full -translate-x-1/2 -translate-y-1/2 z-10"
          style={{
            objectFit: 'cover',
            scale: '1.08',
            filter: 'brightness(1.1) contrast(1.05)'
          }}
          onError={() => {
            console.log('Equipment video failed to load, showing fallback');
            setVideoError(true);
          }}
        >
          <source src="/videos/equipment-720.mp4" type="video/mp4" />
        </video>

        {/* Fallback gradient background - only show if video fails to load */}
        {videoError && (
          <div className="absolute inset-0 bg-gradient-to-br from-black via-purple-950 to-black"></div>
        )}

        {/* Dark Overlay for text readability - 90% opacity, barely see-through */}
        <div className="absolute inset-0 bg-black/90 z-20"></div>
        
        {/* Gradient overlay for aesthetics */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-transparent to-black/60 z-20"></div>
      </div>

      <div className="container mx-auto px-4 lg:px-8 relative z-30">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Professional <span className="bg-gradient-to-r from-purple-400 to-blue-400 bg-clip-text text-transparent">Equipment</span>
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            Industry-standard gear to ensure the highest quality recordings
          </p>
        </div>

        {/* Equipment Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {equipment.map((category, index) => {
            const Icon = iconMap[category.category] || iconMap.default;
            return (
              <div
                key={index}
                className="bg-gradient-to-br from-purple-900/20 to-blue-900/20 backdrop-blur-sm border border-purple-500/20 rounded-xl p-6 hover:border-purple-500/50 transition-all"
              >
                <div className="flex items-center space-x-3 mb-4">
                  <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-purple-600 to-blue-600 flex items-center justify-center">
                    <Icon size={20} className="text-white" />
                  </div>
                  <h3 className="text-xl font-bold text-white">{category.category}</h3>
                </div>
                <ul className="space-y-2">
                  {category.items.map((item, idx) => (
                    <li key={idx} className="flex items-center space-x-2">
                      <span className="w-1.5 h-1.5 rounded-full bg-purple-400"></span>
                      <span className="text-gray-300 text-sm">{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Equipment;